// @ts-check
import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import { useEffect } from 'react';
import { AlignItemsList } from '../components/driver-list-component';
import { getDriversAction } from '../redux/actions/driver-actions';
import { FloatingActionButtonSize } from '../components/add-component';
import ExportActionButtonSize from '../components/export-component';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import { SearchDriversComponent } from '../components/search-drivers-component';
import { LoadingComponent } from '../components/loading-component';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  heading: {
    margin: theme.spacing(2)
  }
}));

// Loop Pro's GetDrivers is ~25s P95 and out of scope to fix. We cache the list
// in Redux across mount/unmount and only re-fetch in the foreground when there
// is no cached data. If the cache is older than this TTL we refresh in the
// background while keeping the cached rows on screen (stale-while-revalidate).
const STALE_MS = 5 * 60 * 1000; // 5 min

export default function DriversPage() {
  const classes = useStyles();

  const { drivers, loading, lastFetchedAt } = useSelector((state) => state.drivers);
  const dispatch = useDispatch();

  useEffect(() => {
    if (drivers.length === 0) {
      // Cold load — show the skeleton.
      dispatch(getDriversAction());
      return;
    }
    const isStale = !lastFetchedAt || Date.now() - lastFetchedAt > STALE_MS;
    if (isStale) {
      // Silent background revalidation — cached rows stay on screen.
      dispatch(getDriversAction({ background: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]); // intentionally fire only on mount; stale-check above gates network

  // Skeleton only on first load. Once we have any cached rows we render them
  // immediately, even if a background revalidation is in flight.
  const showSkeleton = loading && drivers.length === 0;

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {showSkeleton && <LoadingComponent />}
          {!showSkeleton && (
            <>
              <BackNavigationComponent page="Drivers" uri="/" />

              <ExportActionButtonSize excelData={drivers} fileName={'Drivers'} />

              <SearchDriversComponent />

              <AlignItemsList drivers={drivers} />

              <FloatingActionButtonSize />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
